import { Svg, type Props as SvgProps } from './Svg'

export const IconChevronRight = (props: SvgProps) => (
	<Svg
		{...props}
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
		xmlns='http://www.w3.org/2000/svg'
	>
		<polyline points='9 6 15 12 9 18' color='currentcolor' />
	</Svg>
)
